import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Provider, useSelector, useDispatch, shallowEqual } from 'react-redux'
import { BrowserRouter as Router, withRouter,Redirect } from 'react-router-dom'


import GoogleTracker from './googleTracker'

import 'react-rangeslider/lib/index.css'
import './styles.scss'
import SiteConnector from '../components/siteconnector'
import store from '../store'

import ProductSelector from './productSelector'
import Checkout from '../components/pages/checkout'
import PopupNotification from '../components/shared/notification/popup'

import { appInit, resetSelectedProduct, updateViewport } from './action'

import {disableTab, enableTab} from '../utilities/function/common'
import {getDataFromURL} from '../utilities/function/urlparams'
import Viewcart from "../components/pages/viewcart";
import Maintenance from "../components/pages/maintenance";


let App = (props) => {
  const { location, history } = props
  const { fadeoutApp } = useSelector(state => state.app, shallowEqual)
  const dispatch = useDispatch()
  const initFlag = useRef(false)
  const prevURL = useRef(null)
  const prevWindowHeight = useRef(null)
  const setVH = () => {
    let root = document.documentElement
    root.style.setProperty("--vH",window.innerHeight+"px")
  }
  const addFontIcon = () =>{
    const link = document.createElement('link');
    link.id = 'icomoon';
    link.rel = 'stylesheet';
    link.href = 'https://i.icomoon.io/public/5efaa2bbda/OrderingForm/style.css';
    if(window.app_config && window.app_config.font_icon){
      link.href = window.app_config.font_icon;
    }
    document.head.appendChild(link);
  }





  useEffect(()=>{
    if(!initFlag.current){
      appInit(dispatch,history)
      updateViewport(dispatch,window.innerWidth)
      setVH()
      addFontIcon()
      window.addEventListener('resize', ()=>{
        updateViewport(dispatch,window.innerWidth)
        if(prevWindowHeight.current !== window.innerHeight){
          setVH()
          prevWindowHeight.current = window.innerHeight
        }
      });



      initFlag.current = true
    }
  },[dispatch,history,initFlag])
  const urlParams = getDataFromURL (location.search)
  const hideScrollbar = (toggle)=>{
    const HIDE_SCROLLBAR = 'of-hide-scrollbar'
    const html = document.querySelector('html')
    if(toggle){
      html.classList.add(HIDE_SCROLLBAR)
    }else{
      html.classList.remove(HIDE_SCROLLBAR)
    }
  }

  useEffect(()=>{
    if(prevURL.current!== location.search){
      if(location.search==='' || !location.search){
        hideScrollbar(false)
        resetSelectedProduct(dispatch)
      }else{
        if(urlParams && urlParams.a){
          hideScrollbar(true)
          const viewportQuery = "width=device-width, initial-scale=1, user-scalable=no"
          document.querySelector('meta[name="viewport"]').setAttribute("content", viewportQuery)
        }else{
          hideScrollbar(false)
        }
      }
      prevURL.current = location.search
    }
  },[location.search,prevURL,dispatch,urlParams])

  if(urlParams && urlParams.a){
    const { a } = urlParams
    const renderApp = () => {
      //check maintenance

      if(window.app_config && window.app_config.maintenance_enable){
        const {maintenance_enable,maintenance_heading,maintenance_description} = window.app_config
        if(maintenance_enable && maintenance_enable==="on"){
          return (<Maintenance heading={maintenance_heading} description={maintenance_description} /> )
        }
      }

      disableTab()
      switch (a) {
        case 'pay':
        case 'checkout':
        case 'switch':
          enableTab()
          return (<Checkout />)
        case 'add':
          return (<ProductSelector key={a}/>)
        case 'edit':
          return (<ProductSelector key={a}/>)
        case 'viewcart':
          return (<Viewcart />)
        case 'confdomain':
          return (<ProductSelector key={a}/>)
        default:
          enableTab()
          return (<Redirect to={window.location.pathname}/>)
      }
    }
    return (
      <div className={`of-app${fadeoutApp ? ' of-app--fadeout' : ''}`}>
        {renderApp()}
      </div>
    )
  }
  return (<></>)
}

App.propTypes = {
  location: PropTypes.any,
  history: PropTypes.any
}

App = withRouter(App)

function AppWrapper (props) {
  const {app_config} = props
  if (app_config) {
    return (
      <Provider store={store}>
        <Router>
          <GoogleTracker >
            <SiteConnector />
            <App />
            <PopupNotification />
          </GoogleTracker>
        </Router>
      </Provider>
    )
  }
  return (<></>)
}


AppWrapper.propTypes = {
  app_config: PropTypes.object
}

export default AppWrapper
